<template>
  <div :class="{ 'floating': displayMode === 'absolute' }" class="spinner">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="25 25 50 50" class="uk-position-cover">
      <circle cx="50" cy="50" r="20" fill="none" class="rails"></circle>
      <circle cx="50" cy="50" r="20" fill="none" class="train"></circle>
    </svg>
  </div>
</template>
<script>
  export default {
    name: 'loading',
    props: {
      displayMode: {
        type: String,
        default: 'relative'
      }
    }
  }
</script>
<style lang="scss" scoped>
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0px;
    }
    50% {
      stroke-dasharray: 100, 200;
      stroke-dashoffset: -15px;
    }
    100% {
      stroke-dasharray: 100, 200;
      stroke-dashoffset: -125px;
    }
  }
  @keyframes rotate {
    from { transform: rotate(0deg);   }
    to   { transform: rotate(360deg); }
  }
  @mixin size($size) {
    width: $size;
    height: $size;
    &.floating {
      position: absolute;
      top: calc(50% - #{$size}/2);
      left: calc(50% - #{$size}/2);
    }
  }
  $stroke-width: 5px;
  $duration: 1.4s;
  .spinner {
    @include size(70px);
    position: relative;
    &.floating {
      z-index: 1011;
    }
    svg {
      @include size(100%);
      transform-origin: center;
      transition: all .2s ease-in-out;
      animation: rotate $duration linear infinite;
      circle {
        stroke-width: $stroke-width;
      }
      .rails {
        stroke: #D5D5D5;
      }
      .train {
        stroke: #159BD9;
        stroke-linecap: round;
        stroke-dasharray: 27, 262;
        stroke-dashoffset: 0;
        animation: dash $duration ease-in-out infinite;
      }
    }
  }
</style>
